var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_2517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1388_2517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4813 19.9764C15.2133 19.9764 14.9433 19.9404 14.6773 19.8664C13.0573 19.4164 10.2573 18.0124 6.12233 13.8764C1.98833 9.74244 0.583328 6.94344 0.132328 5.32344C-0.157672 4.27844 0.137328 3.15444 0.903328 2.38844L3.12233 0.169443C3.31733 -0.0255566 3.63333 -0.0255566 3.82933 0.169443L7.82933 4.16944C7.99733 4.33844 8.02433 4.60244 7.89133 4.80044L6.11933 7.45944L12.5393 13.8794L15.1983 12.1074C15.3953 11.9734 15.6593 12.0004 15.8293 12.1694L19.8293 16.1694C20.0243 16.3654 20.0243 16.6814 19.8293 16.8764L17.6093 19.0964C17.0383 19.6674 16.2683 19.9764 15.4813 19.9764ZM3.47533 1.23044L1.61033 3.09544C1.09933 3.60644 0.902328 4.35744 1.09633 5.05544C1.51433 6.56044 2.84833 9.18944 6.82933 13.1694C10.8103 17.1514 13.4403 18.4854 14.9443 18.9034C15.6403 19.0964 16.3913 18.8994 16.9023 18.3894L18.7683 16.5234L15.4123 13.1664L12.7533 14.9394C12.5543 15.0714 12.2903 15.0444 12.1223 14.8764L5.12233 7.87644C4.95333 7.70844 4.92733 7.44444 5.05933 7.24544L6.83233 4.58644L3.47533 1.23044Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_2517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9533,
    height: 19.9529,
    fill: "white",
    transform: "translate(0.0227051 19.9764) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1388_2517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9529,
    height: 19.9533,
    fill: "white",
    transform: "translate(0.0227051 0.0231934)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSmall);
export default __webpack_public_path__ + "static/media/PhoneSmall.e5e2c6a0af884af0a7db62cb914a0dac.svg";
export { ForwardRef as ReactComponent };